import VideoPlayer from '../VideoPlayer/VideoPlayer';

const brandVideo = "https://filemanagementbrandacumendlm.s3.us-east-2.amazonaws.com/video/MAIN_VIDEO_FINAL.mp4";

const Resources = () => {
    const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL;
    return (
        <section id="resources" className="py-3">
            <div className="container text-center">
                <div className="row">
                    <h3 className="text-black font-bold text-uppercase pb-5">
                        Resources
                    </h3>
                </div>
                <div className="row pb-5 justify-content-center">
                    <div className="col-12 col-lg-3 mb-5 mb-lg-0 d-flex justify-content-center">
                        <a href="/pdf/DollarsSenseBrandNaming.pdf" target="_blank" rel="noopener noreferrer">
                            <img
                                src={`${awsImageBaseUrl}images/BrandVault/BrandNaming.png`}
                                alt="Powerful Brand Name"
                                className="img-fluid"
                                loading="lazy"
                            />
                        </a>
                    </div>
                    <div className="col-12 col-lg-3 d-flex justify-content-center">
                        <VideoPlayer
                            videoSrc={brandVideo}
                            posterSrc={`${awsImageBaseUrl}images/poster.png`}
                        />
                    </div>
                    <div className="col-12 col-lg-3 d-flex justify-content-center">
                        <a href="/pdf/TheWinningEquationPowerfulBrandNames.pdf" target="_blank" rel="noopener noreferrer">

                            <img
                                src={`${awsImageBaseUrl}images/BrandVault/PowerfulBrandName.png`}
                                alt="Brand Naming"
                                className="img-fluid"
                                loading="lazy"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Resources;